import SearchIcon from '@material-ui/icons/Search';
import { Card, Col, Space, Table, TablePaginationConfig, Typography } from 'antd';
import SearchInput from "./../../InputComponent";
import { useEffect, useState } from  'react';
import SearchDebounceBar from "./../../SearchDebounce";
import { PropertySearch } from "./../../../factories/propertySearchs";
import styles from './../index.module.css';
import { sortHelper } from '../../../helpers/misc/sortHelper'

const { Column } = Table
const { Title } = Typography

const ODSTable = (props: {
    data: object[],
    onRowClick: (record: object | any) => void,
    onSearch: (keyWord: string) => void
}) => {
    const { setSearchTerm, searchTermDebounced, onDebounce } = SearchDebounceBar()
    const [keyWords, setKeyWords] = useState<string[]>([])
    const { data, onRowClick, onSearch } = props
    const paginationConfig: TablePaginationConfig = {
        size: "small",
        showSizeChanger: true,
        showTotal: (total: number, range: [number, number]) => `Total ${total} items, current ${range[0]}-${range[1]}`,
    }
    const handleSearch = (keyWord:string)=>{
        if(keyWord===''){
            onSearch(keyWord)
        }else{
            setSearchTerm(keyWord)
            onDebounce(keyWord)
        }
    }
    
    useEffect(()=>{
        searchTermDebounced && afterDebounce(searchTermDebounced);
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    },[searchTermDebounced])

    useEffect(() => {
        // @ts-expect-error
        props.data.map((dt: {}, index: number) => dt.key = index)
    },[props])

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(keyWords)
        setKeyWords(stackSearchs.add(term))
    }
    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        } 
        onSearch(term)        
    }
    return (
        <Card style={{ margin: '0 15px' }}>
            <Space direction='vertical' size='large' style={{ display: 'flex' }}>
                <Title level={5}>Other Distribution Systems</Title>
                <Col span={8}>
                    <SearchInput 
                        className = 'SearchBar'
                        label='Search' 
                        placeholder="Search Other Distribution Systems"
                        labelShrink = {true}
                        onChange={handleSearch} 
                        endAdornment={<SearchIcon style={{color: '#9a9a9a'}}/>}
                    />
                    <div className='recentlySearchs'>
                        Recently searched:
                        {keyWords.map((keyWord, index) => (
                            <span
                            className={styles['search-item']}
                            onClick={() => onSearch(keyWord)}>
                            {' '}
                            {keyWord}
                            {index === keyWords.length - 1 ? '.' : ','}
                            </span>
                        ))}
                    </div>
                </Col>
                <Table
                    dataSource={data}
                    onRow={record => ({ onClick: () => onRowClick(record) })}
                    pagination={paginationConfig}
                    rowKey={"dsid"}
                >
                    <Column
                        title=""
                        key="index"
                        width='40px'
                        // @ts-ignore ignoring as there are data issues
                        render={(text: string, record: [], index: number) => Number(record?.key) ? Number(record?.key) + 1 : index += 1}
                    />
                    <Column
                        title="Name"
                        dataIndex="name"
                        key="name"
                        sorter={(a: [], b: []) => sortHelper(a, b, 'name')}
                        showSorterTooltip={false}
                    />
                    <Column
                        title="Chain"
                        dataIndex="chain"
                        key="chain"
                        sorter={(a: [], b: []) => sortHelper(a, b, 'chain')}
                        showSorterTooltip={false}
                    />
                    <Column
                        title="Hotel Code"
                        dataIndex="hotelcode"
                        key="hotelcode"
                        sorter={(a: [], b: []) => sortHelper(a, b, 'hotelcode')}
                        showSorterTooltip={false}
                    />
                    <Column
                        title="Property Name (Short)" dataIndex="shortname"
                        key="shortname"
                        sorter={(a: [], b: []) => sortHelper(a, b, 'shortname')}
                        showSorterTooltip={false}
                    />
                    <Column
                        title="Property Name (Long)" dataIndex="longname"
                        key="longname"
                        sorter={(a: [], b: []) => sortHelper(a, b, 'longname')}
                        showSorterTooltip={false}
                    />
                </Table>
            </Space>
        </Card>
    )
}

export default ODSTable
